exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo{cursor:pointer;display:flex;justify-content:center;align-items:center;height:75px;overflow:hidden}.logo-scrolled{transform:translateY(100px);transition:transform .35s ease}.logo-fixed{transform:translateY(0px);transition:transform .35s ease}", ""]);

// exports
